export default {
  title: 'Nieuwe prijs',
  fields: {
    product: {
      label: 'Product',
    },
    is_not_personal: {
      label: 'Zichtbaar voor iedereen',
    },
    is_default: {
      label: 'Standaard',
    },
    visible_to: {
      label: 'Zichtbaar voor',
    },
  },
  buttons: {
    select_all: 'Alles selecteren',
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  feedback: {
    missing_info: 'Ontbrekende informatie',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    price_got_created: 'Prijs aangemaakt',
    price_got_updated: 'Prijs bijgewerkt',
  },
};
